import { Card } from '@repo/shadcn';

import { SectionContainer } from '@components/shared';

import { HeaderBreadcrumb } from '@/components/ui';
import { Route } from '@/constants';

import { SupplierDetailsProvider, useSupplierDetailsContext } from './context';
import { AddSupplierPayment } from './make-payment.component';
import { SupplierPaymentStatus } from './payment-status.component';
import { PurchaseHistory } from './purchase-history.component';
import { SupplierInfo } from './supplier-info.component';
import { SupplierSummary } from './supplier-summary.component';

const SupplierDetailsComponent = () => {
    const { data, isLoading, isError, error } = useSupplierDetailsContext();

    return (
        <SectionContainer
            isLoading={isLoading}
            isError={isError}
            error={error}
            fallbackPath={Route.SUPPLIERS}
        >
            <Card className="grid min-w-0 grid-cols-1 gap-4 overflow-hidden p-3 sm:p-4 lg:grid-cols-[minmax(0,2fr)_minmax(18rem,1fr)]">
                <div className="min-w-0 lg:col-span-2 [&_[aria-current=page]]:break-all">
                    <HeaderBreadcrumb
                        items={[
                            { label: 'Suppliers', href: Route.SUPPLIERS },
                            { label: data?.data?.name || 'Supplier Details' },
                        ]}
                    />
                </div>
                <div className="min-w-0 space-y-4">
                    <SupplierInfo />
                    <SupplierPaymentStatus />
                    <PurchaseHistory />
                </div>
                <div className="min-w-0 space-y-4">
                    <SupplierSummary />
                    <AddSupplierPayment />
                </div>
            </Card>
        </SectionContainer>
    );
};

export const SupplierDetails = () => {
    return (
        <SupplierDetailsProvider>
            <SupplierDetailsComponent />
        </SupplierDetailsProvider>
    );
};

SupplierDetails.displayName = 'SupplierDetails';
